import { useEffect } from 'react';
import type { Canvas } from 'fabric';

/**
 * Freezes canvas interaction while the editor owns the canvas: during playback, so you can't grab
 * objects mid-animation, and while media loads, because an edit made against a half-drawn canvas
 * would be read back as if the missing layers had been deleted.
 */
export const useCanvasInteractionLock = (canvas: Canvas | null, locked: boolean): void => {
  useEffect(() => {
    if (!canvas || !locked) return;

    const prevSelection = canvas.selection;
    const prevSkipTargetFind = canvas.skipTargetFind;

    canvas.discardActiveObject();
    canvas.selection = false;
    canvas.skipTargetFind = true;
    canvas.requestRenderAll();

    return () => {
      canvas.selection = prevSelection;
      canvas.skipTargetFind = prevSkipTargetFind;
    };
  }, [canvas, locked]);
};
